import { isNativeModulesDisabled } from "@memorang/helpers/native-runtime";
import { isWeb } from "@memorang/helpers/platform";

type OneSignalClient = {
	initialize: (appId: string) => void;
	Notifications: {
		requestPermission: (
			fallbackToSettings: boolean,
		) => Promise<boolean> | undefined;
	};
	User: {
		addEmail: (email: string) => void;
	};
};

const loadOneSignal = (): OneSignalClient | null => {
	if (isWeb || isNativeModulesDisabled()) {
		return null;
	}

	try {
		const module = require("react-native-onesignal") as {
			OneSignal?: OneSignalClient;
		};

		return module.OneSignal ?? null;
	} catch (error) {
		if ((globalThis as { __DEV__?: boolean }).__DEV__) {
			console.warn(
				"[onesignal] Native module unavailable, skipping push initialization.",
				error,
			);
		}
		return null;
	}
};

const oneSignalClient = loadOneSignal();

let initialized = false;
let pendingEmail: string | null = null;

export const initializeOneSignal = (appId?: string) => {
	if (!appId || !oneSignalClient || initialized) {
		return;
	}
	oneSignalClient.initialize(appId);
	initialized = true;
	oneSignalClient.Notifications.requestPermission(true);
	if (pendingEmail) {
		oneSignalClient.User.addEmail(pendingEmail);
		pendingEmail = null;
	}
};

export const addOneSignalEmail = (email: string) => {
	if (!oneSignalClient) {
		return;
	}
	if (!initialized) {
		pendingEmail = email;
		return;
	}
	oneSignalClient.User.addEmail(email);
};
